<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
    <v-spacer></v-spacer>
    <v-text-field
        v-model="search"
        append-icon="search"
        label="Suche"
        single-line
        hide-details
      ></v-text-field>
    <v-flex xs12>
      <v-data-table
        :rows-per-page-items="[25, 50, 75]"
        :headers="headers"
        :items="assignees"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.item.email }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.monogram }}</td>
          <td class="deletebutton">
            <EditAssignee :assigneeId="props.item.assigneeId" @itemUpdated="_collectAssignees_"/>
            <DeleteButton :id="props.item.assigneeId" backendRoute="assignees/delete" @itemDeleted="_collectAssignees_"/>
          </td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Ihre Suche nach "{{ search }}" Es wurden keine Ergebnisse gefunden.
          </v-alert>
        </template>
      </v-data-table>
      <NewAssignee @itemCreated="_collectAssignees_"/>
    </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
  export default {
    data () {
      return {
        search: '',
        assignees: [],
      }
    },
    created() {
      this._collectAssignees_()
    },
    methods: {
      changeLocale () {
        this.$vuetify.lang.current = 'sv'
      },
      _collectAssignees_(){
        axios.get('assignees/collect.php')
        .then(({ data }) => {
          this.assignees = data.data
        })
      }
    },
    computed: {
      headers () {
        return [
          { text: 'Email', value: 'email', sortable: true},
          { text: 'Name', value: 'name', sortable: true},
          { text: this.lang.monogram, value: 'monogram', sortable: true},
          { text: ''}
        ]
      }
    },
    components: {
      'DeleteButton': () => import('../components/DeleteButton.vue'),
      'NewAssignee': () => import('../components/assignees/NewAssignee.vue'),
      'EditAssignee': () => import('../components/assignees/EditAssignee.vue'),
    }
  }
</script>

<style lang="css">
.v-input__slot {
  margin-bottom: 20px !important;
}
.v-datatable__actions__select{
  visibility: hidden !important;
}
.v-table__overflow{
  margin-top: 5px;
}
.printbutton, .deletebutton {
padding:0!important;
}
.deletebutton .v-btn {
    min-width: 0;
    padding: 0px!important;
    margin-left:0px;
    margin-right:10px;
}

.deletebutton .v-btn:hover:before, .deletebutton .v-btn:focus:before {
    background-color: transparent;
}
.v-datatable .sortable .v-icon {
  display:none!important;
}
</style>
